// Custom div-based dropdown for the Operation select, styled to match the site.
// Keeps the native #operation <select> in sync so the rest of this file (which
// reads its .value and listens for "change") doesn't need to know it exists.
class CalcSelect {
    constructor(wrapper) {
        this.wrapper = wrapper;
        this.select_ = wrapper.querySelector("#operation");
        this.trigger = wrapper.querySelector(".calc-select__trigger");
        this.triggerText = wrapper.querySelector(".calc-select__trigger-text");
        this.panel = wrapper.querySelector(".calc-select__panel");
        this.list = wrapper.querySelector(".calc-select__list");
        this.isOpen = false;

        this.trigger.addEventListener("click", () => this.isOpen ? this.close() : this.open());

        this.list.addEventListener("click", e => {
            const item = e.target.closest("[role=option]");
            if (!item) return;
            this.select(item);
        });

        this.list.addEventListener("keydown", e => {
            const items = [...this.list.querySelectorAll("[role=option]")];
            const idx = items.indexOf(document.activeElement);
            if (e.key === "ArrowDown") { e.preventDefault(); items[Math.min(idx + 1, items.length - 1)]?.focus(); }
            if (e.key === "ArrowUp") { e.preventDefault(); items[Math.max(idx - 1, 0)]?.focus(); }
            if (e.key === "Enter" || e.key === " ") { e.preventDefault(); items[idx]?.click(); }
            if (e.key === "Escape") { this.close(); this.trigger.focus(); }
        });

        this.trigger.addEventListener("keydown", e => {
            if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                this.open();
            }
        });

        document.addEventListener("click", e => {
            if (this.isOpen && !this.wrapper.contains(e.target)) this.close();
        });
    }

    select(item) {
        this.list.querySelectorAll("[role=option]").forEach(el => {
            const isSelected = el === item;
            el.setAttribute("aria-selected", isSelected);
            el.classList.toggle("is-selected", isSelected);
        });
        this.triggerText.textContent = item.textContent.trim();
        this.select_.value = item.dataset.value;
        this.select_.dispatchEvent(new Event("change", { bubbles: true }));
        this.close();
        this.trigger.focus();
    }

    open() {
        this.isOpen = true;
        this.panel.removeAttribute("hidden");
        this.wrapper.setAttribute("data-open", "");
        this.trigger.setAttribute("aria-expanded", "true");
    }

    close() {
        this.isOpen = false;
        this.panel.setAttribute("hidden", "");
        this.wrapper.removeAttribute("data-open");
        this.trigger.setAttribute("aria-expanded", "false");
    }
}

window.addEventListener("load", () => {
    const operationSelect = document.getElementById("operation");
    const inputs = document.querySelectorAll("#value1, #value2, #value3");

    const calcSelectWrapper = document.getElementById("calc-operation");
    if (calcSelectWrapper) {
        new CalcSelect(calcSelectWrapper);
    }

    operationSelect.addEventListener("change", updateApp);
    inputs.forEach(input => input.addEventListener("input", updateApp));

    // Delay to allow DOM to fully render before accessing outputs
    setTimeout(() => {
        updateApp();
    }, 80);
});

let lastOperation = null;

function updateApp() {

    const operation = document.getElementById("operation").value;
    // 🧠 Only update UI and clear inputs if operation has changed
    if (operation !== lastOperation) {
        updateUI(operation); // will clear inputs
        lastOperation = operation; // update tracker
    }
    performCalculation(operation);
}

function updateUI(operation) {
    const value1Group = document.getElementById("value1-group");
    const value2Group = document.getElementById("value2-group");
    const value3Group = document.getElementById("value3-group");
    const value1Label = document.getElementById("value1-label");
    const value2Label = document.getElementById("value2-label");
    const resultLabel = document.getElementById("result-label");

    value1Group.style.display = "block";
    value2Group.style.display = "block";
    value3Group.style.display = "none";
    resultLabel.innerText = "Result";

    switch (operation) {
        case "add":
        case "subtract":
        case "multiply":
        case "divide":
            value1Label.innerText = "Value 1";
            value2Label.innerText = "Value 2";
            break;
        case "kpa_to_psi":
            value1Label.innerText = "Kilopascals (KPA)";
            value2Group.style.display = "none";
            resultLabel.innerText = "Pounds per square inch (PSI)";
            break;
        case "ftlbs_to_inlbs":
            value1Label.innerText = "Foot-Pounds (FT lbs)";
            value2Group.style.display = "none";
            resultLabel.innerText = "Inch-Pounds (IN lbs)";
            break;
        case "inlbs_to_ftlbs":
            value1Label.innerText = "Inch-Pounds (IN lbs)";
            value2Group.style.display = "none";
            resultLabel.innerText = "Foot-Pounds (FT lbs)";
            break;
        case "in_to_mm":
            value1Label.innerText = "Inches (in)";
            value2Group.style.display = "none";
            resultLabel.innerText = "Millimeters (mm)";
            break;
        case "mi_to_km":
            value1Label.innerText = "Miles (mi)";
            value2Group.style.display = "none";
            resultLabel.innerText = "Kilometers (km)";
            break;
        case "fuel_consumption":
            value1Label.innerText = "Distance (miles)";
            value2Label.innerText = "Fuel Used (gallons)";
            resultLabel.innerText = "Miles Per Gallon (MPG)";
            break;
        case "flex_fuel_blend":
            value1Label.innerText = "Current Ethanol % (e.g. 85)";
            value2Label.innerText = "Target Ethanol % (e.g. 70)";
            resultLabel.innerText = "Gallons of 93 Octane Needed";
            value3Group.style.display = "block";
            break;
    }

    // Show/hide Flex Fuel instructions
    const flexInstructions = document.getElementById("flex-fuel-instructions");
    if (flexInstructions) {
        if (operation === "flex_fuel_blend") {
        flexInstructions.classList.remove("hidden");
        } else {
        flexInstructions.classList.add("hidden");
        }
    }

    const gasolineOutput = document.getElementById("gasoline-output");
    const ethanolOutput = document.getElementById("ethanol-output");
    if (ethanolOutput && gasolineOutput) {
        gasolineOutput.style.display = (operation === "flex_fuel_blend") ? "block" : "none";
        ethanolOutput.style.display = (operation === "flex_fuel_blend") ? "block" : "none";
    }

        // 🔄 Clear inputs when operation changes
    document.getElementById("value1").value = "";
    document.getElementById("value2").value = "";
    document.getElementById("value3").value = "";
}

function performCalculation(operation) {
    const val1 = parseFloat(document.getElementById("value1")?.value) || 0;
    const val2 = parseFloat(document.getElementById("value2")?.value) || 0;
    const val3 = parseFloat(document.getElementById("value3")?.value) || 0;

    const resultDisplay = document.getElementById("result-display");
    const formulaDisplay = document.getElementById("formula-display");

    const gasOut = document.getElementById("gasoline-output");
    const ethOut = document.getElementById("ethanol-output");

    const warningEl = document.getElementById("warning-message");

    if (warningEl) warningEl.innerText = "";

    if (!resultDisplay || !formulaDisplay) {
        console.warn("Essential result containers not found.");
        return;
    }

    // Reset visible output fields
    resultDisplay.classList.remove("has-subresults");
    const standaloneResultDiv = resultDisplay.querySelector(".output__standalone-result");
    if (standaloneResultDiv) standaloneResultDiv.remove();
    if (gasOut) gasOut.innerText = "";
    if (ethOut) ethOut.innerText = "";
    formulaDisplay.innerText = "";

    let result = 0;
    let formula = "";

    if (operation === "flex_fuel_blend") {
        if (!gasOut || !ethOut) {
            console.warn("Skipping flex calc: fuel output fields missing.");
            return;
        }

        if (val1 <= val2 || val1 === 0 || val2 === 0 || val3 === 0) {
            gasOut.innerText = "N/A";
            ethOut.innerText = "";
            formulaDisplay.innerText = "Invalid ethanol values or tank size";

             if (val1 <= val2) {
                warningEl.innerText = "⚠️ Target ethanol % must be less than current ethanol %.";
            } else if (val1 === 0 || val2 === 0 || val3 === 0) {
                warningEl.innerText = "⚠️ Please enter non-zero values for all fields.";
            }

            return;
        }

        const blendFraction = (val1 - val2) / (val2 / 100);
        const gasolineGallons = (blendFraction * val3) / 100;
        const ethanolGallons = val3 - gasolineGallons;

        gasOut.innerText = `Gallons of 93 Octane Needed: ${gasolineGallons.toFixed(2)} gal`;
        ethOut.innerText = `🌽 Gallons of Ethanol Needed: ${ethanolGallons.toFixed(2)} gal`;

        // Trigger highlight effect
        [gasOut, ethOut].forEach(el => {
            el.classList.add("highlighted");
            setTimeout(() => el.classList.remove("highlighted"), 1500); // slightly longer than transition
        });
        resultDisplay.classList.add("has-subresults");
        formulaDisplay.innerText = `(${val1} - ${val2}) / (${val2} / 100) * ${val3} / 100`;
        return;
    }

    // General math
    switch (operation) {
        case "add":
            result = val1 + val2;
            formula = `${val1} + ${val2}`;
            break;
        case "subtract":
            result = val1 - val2;
            formula = `${val1} - ${val2}`;
            break;
        case "multiply":
            result = val1 * val2;
            formula = `${val1} * ${val2}`;
            break;
        case "divide":
            if (val2 === 0) return showError("Cannot divide by zero");
            result = val1 / val2;
            formula = `${val1} / ${val2}`;
            break;
        case "kpa_to_psi":
            result = val1 * 0.145038;
            formula = `${val1} * 0.145038`;
            break;
        case "ftlbs_to_inlbs":
            result = val1 * 12;
            formula = `${val1} * 12`;
            break;
        case "inlbs_to_ftlbs":
            result = val1 / 12;
            formula = `${val1} / 12`;
            break;
        case "in_to_mm":
            result = val1 * 25.4;
            formula = `${val1} * 25.4`;
            break;
        case "mi_to_km":
            result = val1 * 1.60934;
            formula = `${val1} * 1.60934`;
            break;
        case "fuel_consumption":
            if (val2 === 0) return showError("Fuel Used cannot be zero", "N/A");
            result = val1 / val2;
            formula = `${val1} / ${val2}`;
            break;
        default:
            return;
    }

    // Format result
    let displayResult = result;
    let displayFormula = formula;

    if (["fuel_consumption", "kpa_to_psi", "in_to_mm", "mi_to_km"].includes(operation)) {
        displayResult = result.toFixed(2);
    } else {
        const rounded = Math.round(result);
        if (result !== rounded) {
            displayFormula = `Round(${formula})`;
        }
        displayResult = rounded;
    }

    // Add standalone result without removing other children
    const resultNode = document.createElement("div");
    resultNode.className = "output__standalone-result";
    resultNode.innerText = displayResult;
    resultDisplay.insertBefore(resultNode, resultDisplay.firstChild);

    formulaDisplay.innerText = displayFormula;
}




function showError(message, fallback = "N/A") {
    const resultDisplay = document.getElementById("result-display");
    const formulaDisplay = document.getElementById("formula-display");
    if (resultDisplay) resultDisplay.innerHTML = `<div class="output__standalone-result">${fallback}</div>`;
    if (formulaDisplay) formulaDisplay.innerText = message;
}

function copyResult() {
    const result = document.getElementById("result-display").innerText;
    navigator.clipboard
        .writeText(result)
        .then(() => {
            const button = document.querySelector(".copy-button");
            const originalText = button.innerText;
            button.innerText = "Copied!";
            button.disabled = true;
            setTimeout(() => {
                button.innerText = originalText;
                button.disabled = false;
            }, 1500);
        })
        .catch(() => alert("Failed to copy result"));
}
